import React, { useMemo } from "react";
import "./ResourceNavigator.css";
import useResources from "./shared/useResources";
import ResourceDirectory from "./directory/ResourceDirectory";

export default function ResourceNavigator({ isEmbedded = false, onClose }) {
  const { resources, loading, error } = useResources();

  const chapters = useMemo(() => {
    return Array.from(new Set(resources.map((r) => r.Chapter).filter(Boolean)));
  }, [resources]);

  return (
    <div className={`rn-root${isEmbedded ? " rn-embedded" : ""}`}>
      {/* Hosts that pass onClose (the mobile desktop) get an exit bar —
          without it the Resources app has no way back. */}
      {onClose && (
        <div className="win95-toolbar" style={{ flexWrap: "wrap", flex: "none" }}>
          <button type="button" className="win95-btn win95-btn--compact" onClick={onClose}>
            ← Back
          </button>
        </div>
      )}
      {loading ? (
        <div className="rn-results-loading">
          <p className="rn-loading-text">Loading resources…</p>
        </div>
      ) : null}

      {error ? (
        <div className="rn-action">
          <div className="rn-results-empty">
            <p className="mb-body">Could not load resources. Please refresh and try again.</p>
          </div>
        </div>
      ) : null}

      {!loading && !error ? (
        <div className="rn-body">
          <ResourceDirectory
            resources={resources}
            chapters={chapters}
          />
        </div>
      ) : null}
    </div>
  );
}
